
import ProductMixin from "../../node_modules/sitis-nuxt/lib/mixins/ProductMixin";
import Breadcrumbs from "~/components/UI/Breadcrumbs.vue";
import MainContent from "~/components/product/MainContent.vue";
import MainContentLoading from "~/components/product/MainContentLoading.vue";
import {
  Product
} from '~/node_modules/sitisjs/dist/internal/sections/products/models/Product';

export default {
  data: function () {
    return {
      productTypeGruz: [],
      productTypeMashina: [],
    }
  },

  computed: {
    breadcrumbs: function () {
      let categories = [...(this.product?.categories || [])];
      let items = [
        { title: "Главная", path: "/" },
        { title: categories?.[1]?.name, path: `/${categories?.[1]?.slug}` },
        { title: categories?.[2]?.name, path: `/${categories?.[1]?.slug}/${categories?.[2]?.slug}` },
      ]
      items.push({ title: this.product?.name, path: this.$route.path});

      return items
    },
    utpInfo: function () {
      let characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...(t?.characteristics || []))
      });

      const title = characteristics.find((t) => t.slug === "utp-zagolovok")?.values?.[0]?.value;
      const description = characteristics.find((t) => t.slug === "utp-soobshchenie")?.values?.[0]?.value;

      if (!title && !description) {
        return null
      }

      return {
        title,
        description
      }
    },

    faqBlockValue: function () {
      return {
        productId: this.product?.id,

        useApi: true
      }
    },
    articlesBlockValue: function () {
      let characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...t?.characteristics)
      });
      const tags = (characteristics.find((t) => t.slug === 'tegi-novostej-dlya-stranicy-tovara')?.values || []).map((t) => t.slug);
      return {
        tags: tags,
        isApi: true
      }
    },
    seoTagsImageBlockValue: function () {
      const categoryName = (this.product?.name || "");
      let characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...t?.characteristics)
      });
      const imageId = characteristics.find((t) => t.slug === 'izobrazhenie-dlya-bloka-bezopasno-dostavim-gruz')?.values?.[0]?.imageId;
      const nameVinit = characteristics.find((t) => t.slug === 'imya-v-vinitelnom-padezhe')?.values?.[0]?.value;

      let title = `Безопасно доставим ${nameVinit || categoryName} по России`;
      if (this.product?.characteristicGroupId === 2) {
        const nameTvoritelnom = (this.allCharacteristics || []).find((t) => t.slug === 'imya-v-tvoritelnom-padezhe')?.values?.[0]?.value;
        title = `Безопасно доставим груз ${nameTvoritelnom || categoryName} по России`
      }

      return {
        title: title,
        image: imageId
      }
    },
    freightCalculatorBlockValue: function () {
      if (this.product?.characteristicGroupId !== 1) {
        return null
      }
      return {
        title: 'Получить расчет перевозки',
        cargoName: this.product?.name || ""
      }
    },

    isShowAdditionalCharacteristics: function () {
      // 1 - Груз
      // 2 - Машина

      return Boolean(this.product?.characteristicGroupId === 2 && this.additionalCharacteristics.length > 0)
    },
    additionalCharacteristics: function () {
      let characteristics = ((this.product?.characteristics || []).find((t) => t.name === "Дополнительные") || [])?.characteristics || [];
      characteristics = characteristics.filter((t) => t.showInProduct);

      return characteristics
    },
    allCharacteristics: function () {
      const characteristics = this.product?.characteristics || [];

      const list = [];
      characteristics.map((item) => {
        list.push(...(item.characteristics || []))
      });

      return list || []
    },

    extensions: function () {
      return ['seo_heading']
    },

    ourTransportTransportationTitle: function () {
      let name = this.product?.name;
      const parentName = (this.allCharacteristics || []).find((t) => t.slug === "imya-v-roditelnom-padezhe")?.values?.[0]?.value || "";

      return `Наш транспорт для перевозки ${(parentName || name).toLowerCase()}`
    }
  },

  mixins: [ ProductMixin ],

  components: {
    Breadcrumbs,
    MainContent,
    MainContentLoading,

    WhatCanWeTransport: () => import("~/components/category/WhatCanWeTransport"),
    OurTransportTransportation: () => import("~/components/category/OurTransportTransportation"),
    AdditionalCharacteristics: () => import("~/components/product/AdditionalCharacteristics"),
  },

  mounted: async function () {
    await this.getRelatedProducts();
  },

  methods: {
    getRelatedProducts: async function () {
      if (!this.product) {
        setTimeout( async () => {
          await this.getRelatedProducts();
        }, 1000);
        return
      }

      await this.getProductTypeGruz(this.product?.characteristicGroupId);
    },
    getProductTypeGruz: async function (characteristicGroupId) {
      const slugs = ["transport"];
      let filters = [];
      [...(this.allCharacteristics || [])]
          .filter((t) => Boolean(slugs.includes(t.slug)))
          .map((filter) => {
            (filter?.values || []).map((variant) => {
              filters.push(`filter[${filter.slug}]=${variant.slug}`)
            });
          });

      // Собираем поисковый URL
      let url = [
        'page=1',
        `group=${Boolean(characteristicGroupId === 1) ? 2 : 1}`,
        'per-page=10',
          ...filters
      ];
      url = url.join("&");

      // Ищем подходящие товары
      const products = await this.$api.agent.transport.get(`/categories/catalog/products?${ url }`).then((res) => {
        return (res.data || []).map((product) => {
          return new Product(product)
        })
      }).catch(() => {
        return []
      });
      if (products.length <= 0) {
        return
      }

      if (characteristicGroupId === 1) {
        this.productTypeGruz = products;
      }
      if (characteristicGroupId === 2) {
        this.productTypeMashina = products;
      }
    }
  }
}
